module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_0.a24f4212.png";